import { useRef, useCallback } from 'react';
import { Camera } from 'lucide-react';

interface SnapAPicComponentProps {
  onCapture: (file: File) => void;
  disabled?: boolean;
}

export const SnapAPicComponent = ({ onCapture, disabled = false }: SnapAPicComponentProps) => {
  const cameraInputRef = useRef<HTMLInputElement>(null);

  const handleCameraCapture = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    onCapture(files[0]);

    // Reset input so the same file can be selected again
    if (cameraInputRef.current) {
      cameraInputRef.current.value = '';
    }
  }, [onCapture]);

  const handleCameraClick = () => {
    if (!disabled) {
      cameraInputRef.current?.click();
    }
  };

  return (
    <>
      {/* Hidden camera input */}
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleCameraCapture}
        className="hidden"
      />

      {/* Camera Button */}
      <div
        onClick={handleCameraClick}
        className={`flex-1 flex flex-col items-center justify-center border-2 border-dashed rounded-lg p-6 transition-colors ${
          disabled
            ? 'opacity-50 cursor-not-allowed'
            : 'cursor-pointer border-muted-foreground/25 hover:border-primary/50'
        }`}
      >
        <Camera className="h-8 w-8 text-muted-foreground mb-2" />
        <span className="text-xs text-muted-foreground text-center whitespace-nowrap">
          Snap a picture
        </span>
      </div>
    </>
  );
};
